import { render, staticRenderFns } from "./ObjectiveEffectsKeks.vue?vue&type=template&id=39d0a3ec&"
import script from "./ObjectiveEffectsKeks.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEffectsKeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports